import { refId } from "@suse-o11y/ref-id";
import { splice } from "@suse-o11y/splice";
import React from "react";

import { For } from "~/components/for";
import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import type { FormState } from "./_form-state";
import { Selector } from "./_selector";

export interface SeriesSelectorsProps {
	state: FormState;
}

export const SeriesSelectors: React.FC<SeriesSelectorsProps> = ({ state }) => (
	<FormField className="items-stretch" state={state}>
		<FormLabel asChild>
			<div>
				<FormLabel>Series Selectors</FormLabel>
				<FormFieldReset />
			</div>
		</FormLabel>

		{(monitor, field) => (
			<For className="mb-4 space-y-2" each={field.getElements(monitor)}>
				{(value, index) => (
					<Selector
						key={refId(value)}
						onDelete={() => {
							state.setInput(splice(index, 1, []));
						}}
						state={value}
					/>
				)}
			</For>
		)}

		<button
			className="button button-primary uppercase"
			onClick={() => {
				state.setInput((values) => [...values, ""]);
			}}
			type="button"
		>
			Add series selector
		</button>
	</FormField>
);
